import { Injectable, EventEmitter, OnInit } from "@angular/core";

@Injectable()
export class OktaService {
    public loggedIn: boolean = false;
    public user: string;

    onOktaSubmitted = new EventEmitter<any>();
    onOktaAuthenticate = new EventEmitter<OktaDetails>();
    onOktaLogout = new EventEmitter<any>();

    constructor() {
        this.onOktaAuthenticate.subscribe((data: OktaDetails) => {
            this.loggedIn = data.loggedIn;
            this.user = data.user;
        });
    }

    public oktaLogin() {
        this.onOktaSubmitted.emit(true);
    }

    public oktaLogout() {
        this.loggedIn = false;
        this.onOktaLogout.emit(true);
    }
}

export interface OktaDetails {
    loggedIn: boolean;
    user: string;
}
